import { mount } from "@vue/test-utils";
import StepNavigator from "@/components/core/StepNavigator";

jest.mock("@/components/core/StepNavigator", () => ({
  ...jest.requireActual("@/components/core/StepNavigator"),
  methods: {
    watch: jest.fn()
  }
}));

describe("StepNavigator test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(StepNavigator, {
      props: {
        value: new Object(),
        storeAction: "asdas",
        disabled: true,
        vertical: true
      }
    });
  });

  it("Match con el snapshot", async () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  it("Render del component StepNavigator", () => {
    expect(wrapper).toBeDefined();
  });
});
